import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { loadConfig } from "./components/_helpers/configServizi";

// service worker delle push (FCM). Non va chiamato serviceWorker.unregister() di CRA:
// disregistrerebbe questo stesso service worker (e senza di lui le push in background non arrivano)
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(function(registration) {
        console.log("Registration successful, scope is:", registration.scope);
      })
      .catch(function(err) {
        console.log("Service worker registration failed, error:", err);
      });
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  // render DOPO aver caricato la config (dal DB o, in fallback, dal file); .finally -> si renderizza comunque
  loadConfig().finally(() => {
    root.render(
      <>
        <App />
      </>
    );
  });
